const createDelegate = (root) => {
    const listenerMap = [{}, {}];
    const handle = event => handleEvent(event, listenerMap, root);
    const api = {
        on: (eventType, selector, handler, useCapture) => {
            addEventListener(root, eventType, selector, handler, useCapture, listenerMap, handle);
            return api;
        },
        off: (eventType, selector, handler, useCapture) => {
            removeEventListener(root, eventType, selector, handler, useCapture, listenerMap, handle);
            return api;
        },
        destroy: () => {
            removeAllEventListeners(root, listenerMap, handle);
            return null;
        }
    };
    return api;
};

const matchesSelector = (selector, target, root) => {
    if (!selector) {
        return target === root;
    } 
    if (typeof selector === 'string') {
        return target.matches(selector);
    }
    return false;
};

const handleEvent = (event, listenerMap, root) => {
    // Event handling logic
    const type = event.type;
    const phase = event.eventPhase || (event.target !== event.currentTarget ? 3 : 2);
    let listenerList = [];

    // Determine the appropriate phase and get the corresponding listeners
    switch (phase) {
        case 1: // Capturing
            listenerList = listenerMap[1][type] || [];
            break;
        case 2: // At target
            listenerList = [...(listenerMap[0][type] || []), ...(listenerMap[1][type] || [])];
            break;
        case 3: // Bubbling
            listenerList = listenerMap[0][type] || [];
            break;
    }

    // Execute the matched listeners
    for (const listener of listenerList) {
        if (matchesSelector(listener.selector, event.target, root)) {
            listener.handler.call(event.target, event);
        }
    }
};

const addEventListener = (root, eventType, selector, handler, useCapture, listenerMap, handle) => {
    const capture = useCapture || ['blur', 'focus', 'error', 'load', 'resize', 'scroll'].includes(eventType);
    if (!listenerMap[capture ? 1 : 0][eventType]) {
        root.addEventListener(eventType, handle, capture);
        listenerMap[capture ? 1 : 0][eventType] = [];
    }
    listenerMap[capture ? 1 : 0][eventType].push({ selector, handler });
};

const removeEventListener = (root, eventType, selector, handler, useCapture, listenerMap, handle) => {
    const capture = useCapture || ['blur', 'focus', 'error', 'load', 'resize', 'scroll'].includes(eventType);
    const listeners = listenerMap[capture ? 1 : 0][eventType];
    if (listeners) {
        listenerMap[capture ? 1 : 0][eventType] = listeners.filter(listener => {
            return listener.handler !== handler || listener.selector !== selector;
        });

        if (listenerMap[capture ? 1 : 0][eventType].length === 0) {
            root.removeEventListener(eventType, handle, capture);
        }
    }
};

const removeAllEventListeners = (root, listenerMap, handle) => {
    for (const capture of [0, 1]) {
        for (const eventType in listenerMap[capture]) {
            root.removeEventListener(eventType, handle, capture === 1);
        }
    }
};

export { createDelegate };